import React from 'react'
import createIcon, { BRAND_MARK_COLOR } from '@/lib/create-icon'

export const ProgressSpinnerIcon = createIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="black" strokeOpacity="0.1" strokeWidth="2" />
    <path
      d="M19.0711 19.0711C20.4696 17.6725 21.422 15.8907 21.8079 13.9509C22.1937 12.0111 21.9957 10.0004 21.2388 8.17317C20.4819 6.34591 19.2002 4.78412 17.5557 3.6853C15.9112 2.58649 13.9778 2 12 2"
      stroke={BRAND_MARK_COLOR}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>,
)
